/**
 * sl-wq59.6: WebAuthn error classification helpers.
 *
 * Shared predicate used by both the sign-in entry point
 * (sign-in-with-passkey.tsx) and the settings enrol/remove surface
 * (passkey-section.tsx). Lets callers split the catch into "user dismissed
 * the prompt" vs "real failure" without re-implementing the DOMException
 * name check in every component.
 */

/**
 * True when the thrown value is the standard WebAuthn user-cancel signal —
 * a `DOMException` with `name === 'NotAllowedError'` is what the browser
 * raises for `navigator.credentials.{create,get}` when the user dismisses
 * the platform prompt (also used for timeout). Callers typically render a
 * softer "cancelled" toast instead of a red "failed" one.
 */
export function isWebAuthnUserCancel(err: unknown): boolean {
  return err instanceof DOMException && err.name === 'NotAllowedError';
}
